import apiFactory from '../../../api/factory';

type VehicleLookupResource = {

}

type VehicleLookupParam = {
    station_id: number
}

const resource = 'vehicle'
export const GetVehicleLookup = (props: VehicleLookupParam): VehicleLookupResource[] => {
    const {call} = apiFactory();
    const {station_id} = props
    return call(props,`api/v2/${resource}/lookup/station/${station_id}`,'get')
}